import { render, staticRenderFns } from "./RegularSubtitle.vue?vue&type=template&id=1d4b2a91&scoped=true&name=regular-subtitle&"
import script from "./RegularSubtitle.vue?vue&type=script&lang=js&"
export * from "./RegularSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./RegularSubtitle.vue?vue&type=style&index=0&id=1d4b2a91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4b2a91",
  null
  
)

export default component.exports